<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">
          IpsosCX
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        :lg="inProgress||!linkValid?12:8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Reset password-->
      <b-col
        v-if="linkValid&&!inProgress"
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('Reset Password') }} 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('Your Password must contain at least one uppercase, one lowercase, one special character and one digit') }}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-reset-password-form mt-2"
              method="POST"
              @submit.prevent="validationForm"
            >

              <!-- password -->
              <b-form-group
                :label="$t('New Password')"
                label-for="reset-password-new"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="Password"
                  rules="required|password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="reset-password-new"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                :label="$t('Confirm Password')"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required|confirmed:Password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-confirm"
                      v-model="cPassword"
                      :type="password2FieldType"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false:null"
                      name="reset-password-confirm"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button
                block
                type="submit"
                variant="primary"
                :disabled="inProgress"
              >
                {{ btnText }}
              </b-button>

              <b-form-group class="mt-2">
                <v-select
                  id="locale"
                  v-model="locale"
                  :options="optionLocales"
                  :clearable="false"
                  :reduce="item => item.code"
                  label="label"
                  @input="setLocale"
                />
              </b-form-group>

            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('Back to login') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import vSelect from 'vue-select'

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      locale: 'tr',
      optionLocales: [{ code: 'tr', label: 'Türkçe' }, { code: 'en', label: 'English' }],
      linkValid: false,
      cPassword: '',
      password: '',
      sideImg: require('@/assets/images/pages/reset-password-v2.svg'),
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
      inProgress: true,
      btnText: this.$t('Set New Password'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/reset-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    $route() {
      this.checkResetKey()
    },
  },
  created() {
    this.checkResetKey()
  },
  methods: {
    setLocale() {
      localStorage.setItem('locale', this.locale)
      this.$i18n.locale = this.locale
    },
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    checkResetKey() {
      this.inProgress = true
      this.btnText = this.$t('Please wait...')

      useJwt.axiosIns.get(`user/CheckPasswordResetKey/${this.$route.params.resetkey}`)
        .then(response => {
          this.inProgress = false
          this.btnText = this.$t('Set New Password')

          if (response.data === 0) {
            this.$swal({
              icon: 'error',
              title: 'Not Found!',
              text: 'Please check password reset link and try again',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
          } else {
            this.linkValid = true
          }
        })
        .catch(e => {
          console.log(e.status)
          this.inProgress = false
          this.btnText = this.$t('Set New Password')
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.inProgress = true
          this.btnText = this.$t('Please wait...')

          useJwt.axiosIns.post('user/SetNewPassword', { NewPassword: this.password, ResetKey: this.$route.params.resetkey })
            .then(response => {
              this.inProgress = false
              this.btnText = this.$t('Set New Password')
              if (response.data > 0) {
                this.$swal({
                  icon: 'success',
                  title: 'Success!',
                  text: 'New password successfully set.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                setTimeout(() => {
                  this.$router.push({ name: 'auth-login', params: {} })
                }, 2000)
              } else {
                this.$swal({
                  icon: 'error',
                  title: 'Error!',
                  text: 'Please check try again later.',
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                })
              }
            })
            .catch(e => {
              console.log(e.status)
              this.inProgress = false
              this.btnText = this.$t('Set New Password')
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
